export const CONFIRMED_GET_PATIENT_GAPLD = "CONFIRMED_GET_PATIENT_GAPLD"
export const CONFIRMED_CREATE_PATIENT_GAPLD = "CONFIRMED_CREATE_PATIENT_GAPLD"
export const CONFIRMED_DELETE_PATIENT_GAPLD = "CONFIRMED_DELETE_PATIENT_GAPLD"
export const CONFIRMED_EDIT_PATIENT_GAPLD = "CONFIRMED_EDIT_PATIENT_GAPLD"
